var $9205ee863542906a$exports = {};
$9205ee863542906a$exports = {
    "removeButtonLabel": `Entfernen`,
    "removeDescription": `Auf \u{201E}L\xf6schen\u{201C} dr\xfccken, um das Tag zu entfernen.`
};


export {$9205ee863542906a$exports as default};
//# sourceMappingURL=de-DE.mjs.map
